import About from "./about/about";
import BlibliHisteria from "./blibli/blibli-histeria";
import BlibliIllustration from "./blibli/blibli-illustration";
import BlibliCheckoutProjects from "./blibli/blibli-checkout-projects";
import FinalProject from "./uni/final-project";
//import Modelling from "./uni/3d-model";
import Blibli4You from "./blibli/blibli-4-you";
import ContextualVoucher from "./blibli/contextual-voucher";
import Traveloka from "./traveloka/compilation";
import TravelokaFlexibleDiscovery from "./traveloka/flexible-discovery";
import TravelokaMaudi from "./traveloka/maudi";
import TravelokaSedap from "./traveloka/sedap";

// URUTAN GA PENTING
const RouterList = [
  {
    url: "/traveloka-maudi",
    detail: TravelokaMaudi,
  },
  {
    url: "/traveloka-sedap",
    detail: TravelokaSedap,
  },
  {
    url: "/traveloka-flexible-discovery",
    detail: TravelokaFlexibleDiscovery,
  },
  {
    url: "/compilation",
    detail: Traveloka,
  },
  {
    url: "/contextual-voucher",
    detail: ContextualVoucher,
  },
  {
    url: "/blibli-histeria",
    detail: BlibliHisteria,
  },
  {
    url: "/blibli-illustration",
    detail: BlibliIllustration,
  },
  {
    url: "/blibli-4-you",
    detail: Blibli4You,
  },
  {
    url: "/blibli-checkout-projects",
    detail: BlibliCheckoutProjects,
  },
  {
    url: "/final-project",
    detail: FinalProject,
  },
  //{
  //  url: "/3d-model",
  //  detail: Modelling,
  //},
  {
    url: "/about",
    detail: About,
  },
];

export default RouterList;
